module.exports = __webpack_public_path__ + "media/images/smart_phone/portal/slide_01-3f80d9e71b07a3334491f171e5404ff9.jpg";